export default __webpack_public_path__ + "static/media/welcome-to-requiment.d029287c.svg";